import { FC } from "react";

import { Container, Divider, Paper, Stack, Typography } from "@mui/material";

import BasicSelector from "../../../../components/Redux/BasicSelector";
import OptionalSwitch from "../../../../components/Redux/OptionalSwitch";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import {
  getSettingsFormProperty,
  setNumericSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../../slices/settings";
import { validateDuration } from "../../../../validators/duration";
import { validateInteger } from "../../../../validators/integer";
import { SectionProps } from "../../../routes/components/edit_sections/common";
import { DnsLookupFamilyOptions } from "../DnsLookupFamilyOptions";

const Dns: FC<SectionProps> = ({ readonly, tabValue, refresh }) => {
  return (
    <Container component={Paper} maxWidth={false} disableGutters={true}>
      <Stack key={tabValue + refresh} spacing={1} sx={{ m: 3 }}>
        <Typography id={tabValue} variant="h2" sx={{ pt: 2 }}>
          DNS
        </Typography>

        <Divider />
        <SettingSection label="DNS Lookup Family" docsKey="dns-lookup-family">
          <BasicSelector
            path="dnsLookupFamily"
            readonly={readonly}
            options={DnsLookupFamilyOptions}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
          />
        </SettingSection>

        <Divider />
        <SettingSection
          label="DNS Failure Refresh Rate"
          docsKey="dns-failure-refresh-rate"
        >
          <ReduxTextField
            path="dnsFailureRefreshRate"
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>

        <Divider />
        <SettingSection label="DNS Query Timeout" docsKey="dns-query-timeout">
          <ReduxTextField
            path="dnsQueryTimeout"
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>

        <Divider />
        <SettingSection label="DNS Query Tries" docsKey="dns-query-tries">
          <ReduxTextField
            path="dnsQueryTries"
            disabled={readonly}
            setter={setNumericSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateInteger}
          />
        </SettingSection>

        <Divider />
        <SettingSection label="DNS Refresh Rate" docsKey="dns-refresh-rate">
          <ReduxTextField
            path="dnsRefreshRate"
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateDuration}
          />
        </SettingSection>

        <Divider />
        <SettingSection
          label="DNS UDP Max Queries"
          docsKey="dns-udp-max-queries"
        >
          <ReduxTextField
            path="dnsUdpMaxQueries"
            disabled={readonly}
            setter={setNumericSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
            validator={validateInteger}
          />
        </SettingSection>

        <Divider />
        <SettingSection label="DNS Use TCP" docsKey="dns-use-tcp">
          <OptionalSwitch
            path="dnsUseTcp"
            label=""
            title="Use TCP for DNS"
            disabled={readonly}
            setter={setSettingsFormProperty}
            getter={getSettingsFormProperty}
            errorHandler={setSettingsFormError}
          />
        </SettingSection>
      </Stack>
    </Container>
  );
};
export default Dns;
